<template>
  <nav class="navbar navbar-expand-lg navbar-light fixed-top py-5 d-block"
    data-navbar-on-scroll="data-navbar-on-scroll">
    <div class="container">
      <router-link to="/" href="#">
        <img src="../../assets/img/logo1.png" height="60" alt="logo" />
      </router-link>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse border-top border-lg-0 mt-4 mt-lg-0" id="navbarSupportedContent">
        <ul class="navbar-nav ms-auto pt-2 pt-lg-0 font-base align-items-lg-center align-items-start">
          <li class="nav-item px-3 px-xl-4">
            <router-link class="nav-link fw-medium" to="/destinationList">Destinations</router-link>
          </li>
          <li class="nav-item px-3 px-xl-4">
            <router-link class="nav-link fw-medium" to="/apiDoc">API</router-link>
          </li>

          <!-- Conditionally render Login and Sign Up buttons -->
          <li v-if="!isLoggedIn" class="nav-item px-3 px-xl-4">
            <router-link class="nav-link fw-medium" to="/login">Login</router-link>
          </li>
          <li v-if="!isLoggedIn" class="nav-item px-3 px-xl-4">
            <router-link class="btn btn-outline-dark order-1 order-lg-0 fw-medium" to="/register">Sign Up</router-link>
          </li>

          <!-- Conditionally render User Dropdown -->
          <li v-if="isLoggedIn" class="nav-item dropdown px-3 px-xl-4">
            <a class="nav-link dropdown-toggle fw-medium" href="#" id="userMenu" role="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              <img src="https://cdn.pixabay.com/photo/2016/04/15/18/05/computer-1331579_640.png" alt="User Avatar"
                class="rounded-circle" style="height: 30px;" />
              {{ user?.fName }} <!-- Display user's name dynamically -->
            </a>
            <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="userMenu"
              style="border: 1px solid rgb(0 0 0 / 4%); border-radius: 0.5rem;">
              <li><a class="dropdown-item" href="#" @click.prevent="handleProfileClick">Profile</a></li>
              <li><a class="dropdown-item" href="#" @click.prevent="handleSettingsMy">My Requests</a></li>
              <li><a class="dropdown-item" href="#" @click.prevent="handleSettingsClient"
                  v-if="userType == 'Organizer'">Clint Requests</a></li>
              <li>
                <hr class="dropdown-divider">
              </li>
              <li><a class="dropdown-item" href="#" @click.prevent="handleLogoutClick">Logout</a></li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>

  <!-- Loading Screen -->
  <div id="loadingScreen" class="d-flex justify-content-center align-items-center d-none">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import $ from 'jquery';
console.log(process.env.VUE_APP_API_URL);
export default {
  name: 'HeaderPage',
  data() {
    return {
      token: localStorage.getItem('token') || null,
      user: JSON.parse(localStorage.getItem('user')) || {}, // Get user from localStorage
      userType: '',
    };
  },
  computed: {
    isLoggedIn() {
      return !!this.token;
    }
  },
  mounted() {
    this.checkUser();
    // Show popup if user navigates to login and popup hasn't been shown yet
    const hasShownPopup = localStorage.getItem('popupShown') || false;

    if (!hasShownPopup && window.location.pathname === '/login') {
      setTimeout(() => {
        Swal.fire({
          title: 'Verified',
          text: 'You can login now.',
          icon: 'success',
          confirmButtonText: 'OK'
        }).then(() => {
          this.handleLoginClick();
          localStorage.setItem('popupShown', true); // Store in localStorage that the popup has been shown
        });
      }, 100);
    }

    $.ajax({
   url: process.env.VUE_APP_API_URL +'/user-api-doc',
    type: 'GET',
    headers: {
        'userApiCode': ''  // Replace with the actual API code
    },
    success: function(response) {
        console.log('Valid API Code:', response);
        // Display the data based on the API code here
    },
    error: function(xhr) {
        console.error('Error:', xhr.responseText);
        // Handle errors (invalid API code, inactive, etc.)
    }
});


  },
  methods: {
    checkUser() {
      try {
        const user = JSON.parse(localStorage.getItem('user'));

        if (user) {
          this.userType = user.accType; // Set userType based on the stored user object
        } else {
          console.warn('No user found in local storage.');
          // Handle user not found, e.g., redirect to login
        }
      } catch (error) {
        console.error('Error parsing user data:', error);
        // Handle JSON parsing error, e.g., clear local storage or notify user
      }
    },
    handleLoginClick() {
      this.$emit('login-toggle'); // Emit event to show LoginPage
    },
    handleProfileClick() {
      // Handle profile view logic
    },
    handleSettingsMy() {
      const user = JSON.parse(localStorage.getItem('user'));
      const userType = user.accType;
      console.log(userType);
      this.$router.push({ path: `/cus-list` });
      //this.$router.push({ path: `/org-list` });
    },
    handleSettingsClient() {
      const user = JSON.parse(localStorage.getItem('user'));
      const userType = user.accType;
      console.log(userType);
      this.$router.push({ path: `/org-list` });
    },
    handleLogoutClick() {
      localStorage.removeItem('token');
      localStorage.removeItem('user'); // Remove user data from localStorage
      localStorage.removeItem('redirectAfterLogin');
      this.token = null;
      this.user = {}; // Clear user data on logout
      window.location.href = '/';
    }
  },
}
</script>

<style scoped>
.borderR {
  border-radius: 5px;
}

.btn-light.active {
  background-color: #6e6e6e;
  border-color: #48494a;
  color: #fff;
}

#loadingScreen {
  background: rgba(255, 255, 255, 0.8);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  display: none;
  /* Initially hidden */
}
</style>
